import type { OptionTs } from "@ps-bridge/interop";
import * as Option from "@utils/Option";

export const getParamOption = (params: URLSearchParams, key: string): OptionTs<string> => {
  const value = params.get(key);
  return value ? Option.some(value) : Option.none<string>();
};
